import deburr from 'lodash/deburr'

export default function sortOptionsByKey(options, key) {
  options.sort((a, b) => {
    const keyA = deburr((a[key] || '').toString().toUpperCase())
    const keyB = deburr((b[key] || '').toString().toUpperCase())
    if (keyA < keyB) return -1
    if (keyA > keyB) return 1
    return 0
  })
}
